import React from "react";
import Hero from "./components/Hero";
import Problem from "./components/Problem";
import Solution from "./components/Solution";
import Architecture from "./components/Architecture";
import Stakeholders from "./components/Stakeholders";
import Compliance from "./components/Compliance";
import Pilot from "./components/Pilot";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";

export default function App() {
  return (
    <div className="bg-white text-gray-800">
      <Navbar />
      <Hero />
      <Problem />
      <Solution />
      <Architecture />
      <Stakeholders />
      <Compliance />
      <Pilot />
      <Footer />
    </div>
  );
} 